module.exports = __webpack_public_path__ + "img/case-logo-54.87181fce.png";